export default [
    {
        path: "/not-authorized",
        name: "not-authorized",
        component: () => import("@/pages/error/NotAuthorized.vue"),
        meta: {
            pageTitle: "Tidak memiliki izin",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/404-not-found",
        name: "notFound",
        component: () => import("@/pages/error/Error.vue"),
        meta: {
            pageTitle: "Not found",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/login/:redirect?/:ulid?",
        name: "login",
        component: () => import("@/pages/auth/Login.vue"),
        meta: {
            pageTitle: "Login",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/register/:redirect?/:ulid?",
        name: "register",
        component: () => import("@/pages/auth/Register.vue"),
        meta: {
            pageTitle: "Registrasi",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/forgot-password",
        name: "forgotPassword",
        component: () => import("@/pages/auth/ForgotPassword.vue"),
        meta: {
            pageTitle: "Lupa password",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/reset-password",
        name: "resetPassword",
        component: () => import("@/pages/auth/ResetPassword.vue"),
        meta: {
            pageTitle: "Reset password",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/privacy-policy",
        name: "privacyPolicy",
        component: () => import("@/pages/PrivacyPolicy.vue"),
        meta: {
            pageTitle: "Kebijakan Privasi",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
];
